import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

function Home() {

      const navigate = useNavigate();
      const location = useLocation();
    
      const token = localStorage.getItem('token');
      const email = localStorage.getItem('email');
      const role = localStorage.getItem('role');
    
      useEffect(() => {
        const verifyUser = async () => {
          if (!token) {
            navigate('/login');
            return;
          }
    
          try {
            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/user/check-user`,
              { email, role, token }
            );
    
            if (res.data.success) {

                 setTimeout(() => {
        const roleLocal = localStorage.getItem("role");
        if (roleLocal === "ADMIN") navigate("/admin-home", { replace: true });
        else navigate("/user-home", { replace: true });
      }, 700);
            }else {

                 localStorage.removeItem('token');
              localStorage.removeItem('tempToken');
              localStorage.removeItem('email');
              localStorage.removeItem('fullName');
              localStorage.removeItem('role');
              navigate('/login');
            }
          } catch (error) {
            console.error('User verification failed:', error.message);
            localStorage.removeItem('token');
            localStorage.removeItem('tempToken');
            localStorage.removeItem('email');
            localStorage.removeItem('fullName');
            localStorage.removeItem('role');
            navigate('/login');
          }
        };
    
        verifyUser();
      }, [navigate, location.pathname]);


  return (
    <div></div>
  )
}

export default Home